import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import MainLayout from "./MainLayout";
// import {
//   AppRoute,
//   // PrivateRoute,
//   MainLayout,
// } from "./Layout";

import Page404 from "./Page404";

// for home
import Home from "../containers/Home/Home";
import FundDetails from '../containers/Home/FundDetails';
import FundHouse from '../containers/Home/FundHouse'
import AboutUs from "../containers/Home/AboutUs";
import PrivacyPolicy from "../containers/Home/PrivacyPolicy";
import RefundPolicy from "../containers/Home/RefundPolicy";
import TermsConditions from "../containers/Home/TermsConditions";
const Root = () => {
  return (
    <Router>
      <Switch>
        {/* home */}
        <Route
          exact
          path="/"
          render={(props) => (
            <MainLayout {...props}>
              <Home {...props} />
            </MainLayout>
          )}
        />
        {/* <Route exact path="/" component={Home} /> */}
        {/* <Route path="/mutual-funds" component={FundDetails}/> */}
        <Route
          
          path="/mutual-funds"
          render={(props) => (
            <MainLayout {...props}>
              <FundDetails {...props} />
            </MainLayout>
          )}
        />
        <Route
          
          path="/fund_house"
          render={(props) => (
            <MainLayout {...props}>
              <FundHouse {...props} />
            </MainLayout>
          )}
        />
         {/* <Route path="/fund_house" component={FundHouse}/> */}
         <Route
          
          path="/about_us"
          render={(props) => (
            <MainLayout {...props}>
              <AboutUs {...props} />
            </MainLayout>
          )}
        />
        <Route
          
          path="/privacy_policy"
          render={(props) => (
            <MainLayout {...props}>
              <PrivacyPolicy {...props} />
            </MainLayout>
          )}
        />
        <Route
          
          path="/refund_policy"
          render={(props) => (
            <MainLayout {...props}>
              <RefundPolicy {...props} />
            </MainLayout>
          )}
        />
        <Route
          
          path="/terms_conditions"
          render={(props) => (
            <MainLayout {...props}>
              <TermsConditions {...props} />
            </MainLayout>
          )}
        />
         {/* <Route path="/about_us" component={AboutUs}/>
         <Route path="/privacy_policy" component={PrivacyPolicy}/>
         <Route path="/refund_policy" component={RefundPolicy}/>
         <Route path="/terms_conditions" component={TermsConditions}/> */}
        {/* <Route exact path="/thesis" component={Thesis} />
        <Route exact path="/social-stats" component={SocialStats} />
       
        <Route exact path="/faqs" component={Faqs} /> */}
        <Route path="*" component={Page404} />
      </Switch>
    </Router>
  );
};

export default Root;
